var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'clsx';
import { getIconUrl } from '../../design-tokens/style-utilities';
import { StyledListItem, StyledListItemTitle, StyledTypographyListItem, } from './styles/list-item.styled';
/**
 * A list item is a component which should always be rendered inside a list component
 */
const ListItem = (_a) => {
    var { children, class: className = '', icon, title, iconColor, variant = 'basic', dataTest = 'list-item', compact = true, condensed = false } = _a, props = __rest(_a, ["children", "class", "icon", "title", "iconColor", "variant", "dataTest", "compact", "condensed"]);
    const slatClassNames = classNames('PONCHO-list__item', className, {
        [`PONCHO-list__item--checked`]: variant === 'checked',
        [`PONCHO-list__item--marked`]: variant === 'marked',
        [`PONCHO-list__item--inactive`]: variant === 'inactive',
        [`PONCHO-list__item--bulleted`]: variant === 'bulleted',
        [`PONCHO-list__item--numbered`]: variant === 'numbered',
        [`PONCHO-list__item--plussed`]: variant === 'plussed',
        [`PONCHO-list__item--minused`]: variant === 'minused',
    });
    const useTypography = typeof children === 'string' ||
        (Array.isArray(children) &&
            children.some((child) => {
                return typeof child === 'string';
            }));
    const TagName = useTypography ? StyledTypographyListItem : StyledListItem;
    return (_jsxs(TagName, Object.assign({ className: slatClassNames }, (useTypography
        ? {
            variant: condensed ? 'usp-text-sm' : 'body-text',
            tagName: 'li',
        }
        : {}), (icon ? { 'data-icon': getIconUrl(icon, 'illustrative') } : {}), props, { "$variant": variant, "$iconColor": iconColor, "$icon": icon, "$compact": compact }, (useTypography && { dataTest }), { "data-test": dataTest, children: [title && (_jsx(StyledListItemTitle, { variant: "list-title", className: "PONCHO-list__item--title", dataTest: `${dataTest}-title`, children: title })), children] })));
};
export default ListItem;
